import React, {useEffect} from "react";
import {triggerOnArticleListUI} from "../../../../triggers/triggerOnArticleList";
import {GenerateSummary} from "../../../../widgets/generateSummary";
import {populateArticleActions} from "../../../../utils/articleList/articleActions";
import {textbookCardEvents} from "../../../../utils/articleList/textbookCardEvents";
import {addClass} from "../../../../utils/generateClassName";
import {storeInCache} from "../../../../utils/manageStoreCacheData";
import {isTrue} from "../../../../utils/generalUtils";


/**
 * Generate a Textbook articleList listType
 *
 * @param pageParams params from generatePages
 * @returns {*}
 * @constructor
 */
const GenerateTextbookPage = (pageParams) => {
	pageParams = Object.assign({
		props: {},
		mops: {},
		entries: [],
		fullList: [],
		page: 0,
		entryPage: 0,
		updateHistoryState: false
	}, pageParams);
	const props = pageParams.props;

	const articleDisplayParams = props.hasOwnProperty('articleDisplayParams') ? props.articleDisplayParams : {};
	const pageList = pageParams.entries;
	const articleList = pageParams.fullList;

	const displayClassName = 'display-page' + (pageParams.page === pageParams.entryPage ? ' selected' : '');
	const className = 'textbook-page';
	const articleClassBase = 'textbook-entry';

	const articleActions = populateArticleActions({
		props: props,
		mops: pageParams.mops,
		articleList: articleList,
		updateHistoryState: isTrue(pageParams.updateHistoryState)
	});

	// add front-end event handlers to articleActions
	articleActions.cardEvents = textbookCardEvents;

	/**
	 * These triggers require that the articleList be built in the UI before activation, so place in a
	 * useEffect that activates at the end of the jsx
	 *
	 * Note: listType ('default'/'carousel' will make a different scroll call in the trigger.
	 */
	const articleId = props.articleId;
	const listType = props.hasOwnProperty('listType') ? props.listType : 'default';
	useEffect(() => {
		const triggerParams = {
			module: 'articleList',
			storageKey: props.storageKey,
			listType: listType,
			articleId: articleId,
			articleListKey: pageParams.mops.queryParams,
			scrollToSelection: isTrue(props.scrollToSelection),
			scrollToLastPosition: isTrue(props.scrollToLastPosition),
			section: props.section
		};
		triggerOnArticleListUI(triggerParams);
	});

	return (
		<div className={displayClassName} data-page={pageParams.page}>
			<ul className={className}>
				{
					pageList.map((article) => {
						const categories = Array.isArray(article.categories) ? article.categories : [];
						const categoriesClasses = categories.map(category => category.trim() !== '' ? 'category-' + category.trim() : '');
						const articleClassList = categoriesClasses.concat([
							'card-' + articleDisplayParams.cardTemplate,
							'article-' + article.articleId,
							'issue-' + article.issueId,
							(props.articleId && props.articleId === article.articleId) ? 'article-current' : ''
						]);
						const articleClass = addClass(articleClassBase, articleClassList);
						return (
							<li key={article.id} data-articleid={article.id} data-issueid={article.issueId} className={articleClass}>
								<GenerateSummary entry={article} actions={articleActions} template={articleDisplayParams.cardTemplate} displayParams={articleDisplayParams} />
							</li>
						);
					})
				}
			</ul>
		</div>
	);
};
export {GenerateTextbookPage};
